<template>
    <!-- Start Main Content -->
    <div class="main-content group-data-[sidebar-size=lg]:xl:ml-[calc(theme('spacing.app-menu')_+_16px)] group-data-[sidebar-size=sm]:xl:ml-[calc(theme('spacing.app-menu-sm')_+_16px)] px-4 group-data-[theme-width=box]:xl:px-0 ac-transition">
        <div class="card">
            <h2 class="card-title">Total Orders</h2>
        </div>
        
        <div class="grid grid-cols-12">
            <!-- INITIALIZE CSS CLASS -->
            <div class="hidden">
                <div class="self-center md:col-span-6 md:place-self-end lg:col-span-full inline-block w-auto ml-2 dark:bg-dark-card-two dark:text-white align-middle"></div>
                <div class="hover:bg-primary-500 hover:text-white dark:bg-gray-800 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-white"></div>
                <div class="text-slate-300 border-slate-300 dark:!bg-gray-400 dark:text-slate-300 bg-slate-200/50 first:rounded-l-lg last:rounded-r-lg"></div>
                <div class="dark:bg-gray-700 dark:!rounded-none transition-all duration-150 ease-linear [&.selected]:bg-[#F2F4F9] dark:[&.selected]:bg-dark-icon"></div>
                <div class="group-[.bordered]:rounded-none group-[.bordered]:border group-[.bordered]:border-gray-200 dark:group-[.bordered]:border-dark-border"></div>
            </div>
            
            <div class="tablejs sr-only size-0"></div>
         <!-- ------------------------------------------------------------------------------------------------------ -->



           <div class="col-span-full">
                <div class="card p-0">
                   <div class="px-6 py-4 border-b border-gray-200 dark:border-gray-700 bg-gray-100 dark:bg-gray-900 rounded-t-xl">
                    <div class="flex space-x-4">
                        <h2 class="text-xl font-semibold text-gray-800 dark:text-white">
                            <h2>Shirt:- <span class="text-danger">{{ total_qty.shirt_qty || 0 }}</span></h2>
                        </h2>
                        <h2 class="text-xl font-semibold text-gray-800 dark:text-white ml-4">
                            <h2>Pant:- <span class="text-danger">{{ total_qty.pant_qty || 0 }}</span></h2>
                        </h2>
                    </div>
                </div>

                    <div class="p-6 space-y-4">
                   <div class="grid grid-cols-3 gap-4">
                    <div v-for="(item, index) in order_items" :key="item.id" class="bg-white dark:bg-gray-800 shadow-md rounded-xl p-4 border border-gray-200 dark:border-gray-700">
                        <div class="text-lg font-semibold text-gray-800 dark:text-white">
                      {{  index+1 +'.'+ item.stich_name + '(' + item.prd_name + ')' }}
                        </div>

                     <span class="text-danger">
                    Delivery Date:- {{item.deliverydate && item.deliverydate !== '0000-00-00' ? item.deliverydate : 'No date'}}
                    </span>

                        <div class="mt-3 flex items-center justify-end">
                        <button class="btn-icon btn-primary-icon-light size-7" @click="all_measurement(item.id)">
                            <i class="ri-eye-line text-gray-900 dark:text-dark-text text-[14px]"></i>
                        </button>&nbsp;
                          <button class="btn-icon btn-primary-icon-light size-7" @click="mark(item.id,item.markstatus)">
                                    <i class="ri-check-line text-gray-900 dark:text-dark-text text-[14px]"></i>
                                    </button>&nbsp;

                                   <span :class="{
                                            'text-danger': item.markstatus == 0,
                                            'text-warning': item.markstatus == 1,
                                            'text-success': item.markstatus == 2
                                            }">
                                            {{ item.markstatus == 0 ? 'Pending' : item.markstatus == 1 ? 'Processing' : 'Complete' }}
                                            </span>

                        </div>
                    </div>
                    </div>

                    </div>
                    <!-- Prism Code -->
                    <div class="p-6 hidden">
                        <pre>
                            <code class="language-markup">
                                &lt;p>Sorry we can't show the huge data &lt;/p>
                            </code>
                        </pre>
                    </div>
                    <!-- Prism Code -->
                </div>
            </div>


            <!-- ------------------------------------------------------------------------------------------------------ -->
        </div>
    </div>
    <!-- End Main Content -->
    
    <!-- Start Delete Modal -->
    <!-- End Delete Modal -->
</template>
<script>
import axios from 'axios';
export default {
  data() {
    return {
    

      order_items:[], 
      queryid:'',
      total_qty:[],
       
    };
  },
  computed: {
   
  },
  mounted() { 
      if(this.$route.query.q)
            this.getBasics(this.$route.query.q); 
  },
  methods: {
     async getBasics(invoiceid) {
         
           var self=this;

            self.queryid = invoiceid;
             axios.post('getmeasurementdetails',{invoiceid:invoiceid}).then(function (response) {
                         self.order_items=response.data.order_items;
                         self.employees=response.data.userDetails;
                         self.invDetails=response.data.invDetails;
                         self.customer=response.data.customer;
                          self.total_qty=response.data.total_qty;
                        self.order_items_under=response.data.order_items_details;
                        try {
                            document.getElementById("loader").remove();  
                            sel.printReceipt();
                        } catch (e) {}
                    }).then(()=>{ 
                        
                        
                        
                    //     self.printReceipt();
                  
                        });;
      },

  


  all_measurement(id)
        {

          //  alert(id);
             
               // window.open('/print?q='+id, '_blank');
              //  window.open('/MeasurementDetails?q='+id, '_blank'); 
             this.$router.push({ path: '/allmeasurement', query: { q: id } });

        },


  mark(id,markstatus) {

    let newStatus = (markstatus == 1) ? 2 : 1;
    let queryid = this.queryid;
       var self=this;
         axios.post('getMarkMeasurement',{id:id ,newStatus: newStatus,queryid:queryid}).then(function (response) {
              self.order_items=response.data.order_items;
                 self.reply=response.data.reply;
              //   self.swal(self.reply);

          
                
                }).then(()=>{ 
            
         
                    }); 
  }, 


  },
};
</script>


